import React, { useState, useContext, useEffect } from 'react'
import { getFunctions, httpsCallable } from "firebase/functions";

import Button from '@/components/Button'
import Toggle from '@/components/Toggle'
import { AuthContext } from '@/contexts/AuthContext'
import resolveErrors from '@/utils/resolveErrors'
import { toast } from 'react-toastify';
import Toast from '@/components/Toast'
import { CogIcon } from '@heroicons/react/solid';

export default function SettingsPreferences() {

  return (
    <div className="grid gap-6">
      <PrivacyForm />
      {/* <CommunityForm /> */}
    </div>
  )
}

const PrivacyForm = () => {
  // const [ghostEnabled, setGhostEnabled] = useState(false) // load user settings
  const functions = getFunctions();
  const updateUserPrivacy = httpsCallable(functions, 'updateUserPrivacy');
  const { user } = useContext(AuthContext)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [serverErrors, setServerErrors] = useState(null)
  const [statsEnabled, setStatsEnabled] = useState(user?.privacy?.stats) // load user settings
  const [raceEnabled, setRaceEnabled] = useState(user?.privacy?.race) // load user settings

  const onSubmitHandler = async (e) => {
    e.preventDefault()
    try {
      setIsSubmitting(true)
      await updateUserPrivacy({ stats: statsEnabled, race: raceEnabled })
        .then(() => {
          toast(<Toast icon={<CogIcon className="h-6 w-6 text-gray-300" />} text={`Privacy settings updated successfully.`} />)
        })
    } catch (err) {
      setServerErrors(resolveErrors(err))
    }
    setIsSubmitting(false)
    // no validation needed here
  }

  useEffect(() => {
    setStatsEnabled(user?.privacy?.stats)
    setRaceEnabled(user?.privacy?.race)
  }, [user])

  return (
    <form onSubmit={onSubmitHandler} className="border border-gray-800 rounded">
      <div className="px-4">
        <div className="py-4 border-b border-gray-800">
          <h2 className="font-medium text-xl mb-2">Privacy</h2>
          <p className="text-gray-300">User privacy is one of the core values of Duel. These settings allow you to be completely anonymous from the rest of the players.</p>
        </div>
        <div className="py-3 grid gap-4">
          {/* <div className="flex">
            <Toggle checked={ghostEnabled} onChange={setGhostEnabled} />
            <div onClick={() => setGhostEnabled(!ghostEnabled)} className="ml-4">
              <p className="font-medium text-gray-300">Enable Ghost Mode</p>
              <p className="text-gray-300">Your bets won't appear in public bet feed and bet preview</p>
            </div>
          </div> */}
          <div className="flex">
            <Toggle checked={statsEnabled} onChange={setStatsEnabled} />
            <div onClick={() => setStatsEnabled(!statsEnabled)} className="ml-4">
              <p className="font-medium text-gray-300">Hide all your statistics</p>
              <p className="text-gray-300">Other users won't be able to view your wins, losses and wagered statistics</p>
            </div>
          </div>
          <div className="flex">
            <Toggle checked={raceEnabled} onChange={setRaceEnabled} />
            <div onClick={() => setRaceEnabled(!raceEnabled)} className="ml-4">
              <p className="font-medium text-gray-300">Hide all your race statistics</p>
              <p className="text-gray-300">Other users won't be able to view your race statistics</p>
            </div>
          </div>
          {serverErrors && <p>{serverErrors}</p>}
        </div>
      </div>
      <div className="bg-gray-800 bg-opacity-50 border-t border-gray-800 px-4 py-3 flex justify-between items-center">
        <p className="text-gray-300 flex-1">Please allow up to 30 seconds for update to take effect.</p>
        <Button modifier="secondary" rounded="rounded-full" type="submit" className="py-2.5 px-4">
          {isSubmitting ? (
            <span className="flex items-center justify-center">
              Processing
              <svg className="animate-spin ml-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </span>
          ) : (
            <span>Save</span>
          )}
        </Button>
      </div>
    </form>
  )
}

const CommunityForm = () => {
  const [rainEnabled, setRainEnabled] = useState(false) // load user settings

  const onSubmitHandler = e => {
    e.preventDefault()
    // no validation needed here
  }

  return (
    <form onSubmit={onSubmitHandler} className="border border-gray-800 rounded">
      <div className="px-4">
        <div className="py-4 border-b border-gray-800">
          <h2 className="font-medium text-xl">Community</h2>
        </div>
        <div className="py-3 grid gap-4">
          <div className="flex">
            <Toggle checked={rainEnabled} onChange={setRainEnabled} />
            <div onClick={() => setRainEnabled(!rainEnabled)} className="ml-4">
              <p className="font-medium text-gray-300">Exclude from rain</p>
              <p className="text-gray-300">Prevents you from receiving a rain in chat</p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-gray-800 bg-opacity-50 border-t border-gray-800 px-4 py-3 flex justify-between items-center">
        <p className="text-gray-300">Please allow up to 30 seconds for update to take effect.</p>
        <Button type="submit" className="py-2.5 px-4">Save</Button>
      </div>
    </form>
  )
}